import React from "react";

import { Box } from "@chakra-ui/react";

import useStore from "../../../../store";

import { AnswerFragment } from "../../../../graphql/generated/definitions";

const TextareaLikeBox: React.FC<{
  id: string;
  value: string;
  answer: AnswerFragment;
}> = ({ id, value, answer }) => {
  const viewer = useStore((state) => state.viewer);

  return (
    <Box
      id={id}
      py="2"
      px="3"
      fontSize="sm"
      maxWidth="2xl"
      whiteSpace="pre-wrap"
      border="1px solid"
      borderColor="inherit"
      rounded="sm"
      color="darkBrand"
      cursor="not-allowed"
      bgColor={answer.userId === viewer.id ? "gray.50" : "gray.100"}
    >
      {value}
    </Box>
  );
};

export default React.memo(TextareaLikeBox);
